import { $, $$ } from 'utils/dom';
import { APILazerLoader } from 'modules/lazer-loader';
import { getPlyr, PlyrPlayer } from 'modules/plyr/create-plyr';

// ---- create player
const createPlayer = async (api, container) => {
  const pl = container.classList.contains('plyr-audio')
    ? new PlyrPlayer(api, container, audioPlayerOptions)
    : new PlyrPlayer(api, container, {});
  const player = await pl.create();
  const duration = player.duration; // get duration in seconds
  const durationOutput = getDuration(duration);
  return { player: player, duration: durationOutput };
};

const getDuration = duration => {
  const hours = Math.floor(duration / 3600);
  let minutes = Math.floor((duration - hours * 3600) / 60);
  let seconds = Math.round(duration % 60);
  if (minutes < 10) minutes = '0' + minutes;
  if (seconds < 10) seconds = '0' + seconds;
  let durationOutput;
  if (hours > 0) {
    durationOutput = `${hours}:${minutes}:${seconds}`;
  } else {
    durationOutput = `${minutes}:${seconds}`;
  }
  return durationOutput;
};

const observe = targets => {
  new APILazerLoader({
    targets,
    config: {
      rootMargin: '50px 0px',
      threshold: 0.01,
    },
    cb: async (api, { target }) => {
      const { duration } = await createPlayer(api, target);

      if (target.classList.contains('plyr-audio')) {
        const durationSelector = $(
          '.plyr__time--duration',
          target.parentElement
        );
        durationSelector.innerHTML = duration;
      }
    },
    loadAPI: () => getPlyr(),
  }).init();
};

const audioPlayerOptions = {
  hideControls: false, // it is set to false to make it easier to work with (just for development phase)
  controls: [
    'play', // Play/pause playback
    'progress', // The progress bar and scrubber for playback and buffering
    'current-time', // The current time of playback
    'duration', // The full duration of the media
    // 'mute', // Toggle mute
    // 'volume', // Volume control
  ],
};

const $$media = $$('.plyr-video, .plyr__video-embed, .plyr-audio');
$$media.length && observe($$media);
